import { call, put, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  addData5SCardSuccess,
  addData5SCardFailure,
  updateData5SCardSuccess,
  updateData5SCardFailure,
  deleteData5SCardSuccess,
  deleteData5SCardFailure,
} from './actions';
import { addStrapiData, deleteStrapiData, extractStrapiData, updateStrapiData } from '../../api/api';
import { fetchData } from '../filtersData/actions';
import { AddRequestAction, DeleteRequestAction, UpdateRequestAction } from '../../types/strapiMyTasks';
import { selectCurrentUser } from 'src/modules/users/selector';
import { buildMy5SCardsFilters } from '../../components/audits5sMainPage/my5SCardsFetch';

export function* addData5SCardSaga(action: AddRequestAction) {
  const { modelName, data } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(addStrapiData, modelName, data);
    const extractedData = extractStrapiData(response);
    yield put(addData5SCardSuccess(modelName, extractedData));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(addData5SCardFailure(modelName, errorMessage));
  }
}

export function* updateData5SCardSaga(action: UpdateRequestAction) {
  const { modelName, documentId, data } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(updateStrapiData, modelName, documentId, data);
    const extractedData = extractStrapiData(response);
    yield put(updateData5SCardSuccess(modelName, extractedData));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(updateData5SCardFailure(modelName, errorMessage));
  }
}

export function* deleteData5SCardSaga(action: DeleteRequestAction) {
  const { modelName, documentId } = action.payload;
  try {
    yield call(deleteStrapiData, modelName, documentId);
    yield put(deleteData5SCardSuccess(modelName, documentId));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(deleteData5SCardFailure(modelName, errorMessage));
  }
}

export function* refreshCardsAfterSuccess(): Generator<any, void, any> {
  const currentUser = (yield select(selectCurrentUser)) as any;
  const email = currentUser?.email?.toLowerCase();
  yield put(fetchData('mt-5-s-cards', email ? buildMy5SCardsFilters(email) : {}, { page: 1, pageSize: 500 }));
}
